import { Dispatch } from 'redux';

import {
  dismissNotifications as apiDismissNotifications,
  fetchNotifications as apiFetchNotifications,
} from 'api/apiUserNotificationEndpoints';
import { MappedNotification } from 'types/mappedNotifications/MappedNotification';
import { sortNotifications } from 'utils/userNotifications';

// Types

export type MainStoreUserNotificationsState = {
  notifications: MappedNotification[];
  isFetching?: boolean;
  isLoaded: boolean;
};

type FetchNotificationsRequestAction = {
  type: 'NOTIFICATIONS_FETCH_REQUEST';
};

type FetchNotificationsSuccessAction = {
  type: 'NOTIFICATIONS_FETCH_SUCCESS';
  notifications: MappedNotification[];
};

export type MainStoreUserNotificationsAction =
  | FetchNotificationsRequestAction
  | FetchNotificationsSuccessAction;

// Reducer

export function userNotificationsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreUserNotificationsState = {
    notifications: [],
    isLoaded: false,
  },
  action: MainStoreUserNotificationsAction
) {
  switch (action.type) {
    case 'NOTIFICATIONS_FETCH_REQUEST':
      return { ...state, isFetching: true };

    case 'NOTIFICATIONS_FETCH_SUCCESS':
      return {
        ...state,
        notifications: action.notifications,
        isFetching: false,
        isLoaded: true,
      };

    default:
      return state;
  }
}

// Actions

const fetchNotificationsRequest = (): FetchNotificationsRequestAction => ({
  type: 'NOTIFICATIONS_FETCH_REQUEST',
});

const fetchNotificationsSuccess = (
  notifications: MappedNotification[]
): FetchNotificationsSuccessAction => ({
  type: 'NOTIFICATIONS_FETCH_SUCCESS',
  notifications,
});

export const fetchNotifications =
  () =>
  (
    dispatch: Dispatch<MainStoreUserNotificationsAction>,
    getState: () => { userNotifications: MainStoreUserNotificationsState }
  ) => {
    const notifications = getState().userNotifications;

    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (notifications && notifications.isFetching) {
      return Promise.resolve() as Promise<void>;
    }

    dispatch(fetchNotificationsRequest());
    return apiFetchNotifications().then((fetchedNotifications) => {
      const sortedNotifications = sortNotifications(fetchedNotifications);
      dispatch(fetchNotificationsSuccess(sortedNotifications));
    });
  };
export const dismissNotifications =
  (ids: Array<string>) =>
  (dispatch: Dispatch<MainStoreUserNotificationsAction>) => {
    dispatch(fetchNotificationsRequest());
    return apiDismissNotifications(ids).then((fetchedNotifications) => {
      // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      const sortedNotifications = sortNotifications(fetchedNotifications);
      dispatch(fetchNotificationsSuccess(sortedNotifications));
    });
  };
